import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/main.css";
import { t, state } from "./i18n";

Vue.config.productionTip = false;

Vue.prototype.$t = t;
Vue.prototype.$i18n = state;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
